import React from 'react';
import { withTranslation } from 'react-i18next';
import Highlight from 'react-highlight.js';

class ErrorBoundary extends React.Component {
  state = {
    hasError: false,
    error: ''
  };

  // static getDerivedStateFromError(error, errorInfo) {
  //   console.log('errorInfo :>> ', errorInfo);
  //   return {
  //     hasError: true,
  //     error: error
  //   };
  // }

  componentDidCatch(error, errorInfo) {
    // Catch errors in any components below and re-render with error message
    this.setState({
      hasError: true,
      error: error,
      errorInfo: errorInfo
    });
    // You can also log error messages to an error reporting service here
  }

  render() {
    if (this.state.hasError) {
      // Error path
      return (
        <div style={{ border: '1px solid red', padding: '10px' }}>
          <strong style={{ color: 'red' }}>
            Ooooo... You broke it. Bummer.
          </strong>

          <details style={{ whiteSpace: 'pre-wrap' }}>
            <summary style={{ cursor: 'pointer', outline: 'none' }}>
              Show Error Details
            </summary>
            <Highlight>
              {this.state.error && this.state.error.toString()}
            </Highlight>

            <h4>Call Stack:</h4>
            <Highlight>
              {this.state.errorInfo && this.state.errorInfo.componentStack}
            </Highlight>
          </details>
        </div>
      );
    }
    // Normally, just render children
    return this.props.children;
  }
}

export default withTranslation()(ErrorBoundary);
